import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
	sx?: SxProps<Theme>;
	fill?: string;
};

export const PendingReviewIcon = ({ sx, fill }: Props) => {
	return (
		<SvgIcon width='17' height='17' viewBox='0 0 17 17' fill='none' sx={sx}>
			<path
				d='M8.33333 0C3.75 0 0 3.75 0 8.33333C0 12.9167 3.75 16.6667 8.33333 16.6667C12.9167 16.6667 16.6667 12.9167 16.6667 8.33333C16.6667 3.75 12.9167 0 8.33333 0ZM8.33333 15C4.65833 15 1.66667 12.0083 1.66667 8.33333C1.66667 4.65833 4.65833 1.66667 8.33333 1.66667C12.0083 1.66667 15 4.65833 15 8.33333C15 12.0083 12.0083 15 8.33333 15ZM8.75 4.16667H7.5V9.16667L11.8333 11.8333L12.5 10.75L8.75 8.5V4.16667Z'
				fill={fill ?? '#E64A19'}
			/>
		</SvgIcon>
	);
};
